import { render, staticRenderFns } from "./agogis-assign-to-lesson-form-reduced.vue?vue&type=template&id=5342b80e"
import script from "./agogis-assign-to-lesson-form-reduced.vue?vue&type=script&lang=ts"
export * from "./agogis-assign-to-lesson-form-reduced.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports